import { changeBackground, elRemove, size } from "./helpers.js";

export function startPhoneAnimation() {
  const moneyPhone = document.querySelector(".money-phone");
  const notification = document.querySelector(".money-phone__notification");
  const phoneWrap = document.querySelector(".money-phone__wrap");
  const comingItems = document.querySelectorAll(".money-phone__coming-item");
  const comingMoneyElements = document.querySelectorAll(
    ".money-phone__coming-money"
  );
  const moneyElement = document.querySelector(".money-phone__value1");
  const logo = document.querySelector(".logo");
  const tigerWin = document.querySelector(".tiger-win");

  if (
    !moneyPhone ||
    !notification ||
    !phoneWrap ||
    !comingItems ||
    !comingMoneyElements ||
    !moneyElement ||
    !logo ||
    !tigerWin
  )
    return;

  comingMoneyElements.forEach((element) => {
    element.textContent = "607 333.33";
  });

  notification.classList.add("on");

  setTimeout(() => {
    phoneWrap.style.display = "flex";
    notification.classList.remove("on");
    elRemove(notification);

    setTimeout(() => {
      phoneWrap.classList.add("show");
    }, 100);

    let currentMoneyValue = 0;
    moneyElement.textContent = "0";

    function processItem(index) {
      if (index >= comingItems.length) {
        setTimeout(() => {
          // В конце ставим точное значение
          moneyElement.textContent = "1 822 000";
          logo.style.display = "block";
          tigerWin.style.display = "block";
          const backgroundUrl = size();
          changeBackground(backgroundUrl);
          elRemove(moneyPhone);
          window.finalSound();
        }, 2000);
        return;
      }

      setTimeout(
        () => {
          comingItems[index].classList.add("on");

          setTimeout(() => {
            // Анимация набегания средств для каждого шага
            const targetValues = [607333, 1214666, 1822000];
            animateMoneyValue(
              moneyElement,
              currentMoneyValue,
              targetValues[index],
              800
            );
            currentMoneyValue = targetValues[index];

            setTimeout(() => {
              processItem(index + 1);
            }, 500);
          }, 300);
        },
        index === 0 ? 0 : 500
      );
    }

    processItem(0);
  }, 1000);
}

function animateMoneyValue(element, startValue, targetValue, duration = 800) {
  const startTime = Date.now();

  function update() {
    const currentTime = Date.now();
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    const easeOutQuart = 1 - Math.pow(1 - progress, 4);
    const currentValue = Math.floor(
      startValue + (targetValue - startValue) * easeOutQuart
    );

    element.textContent = formatMoney(currentValue);

    if (progress < 1) {
      requestAnimationFrame(update);
    } else {
      element.textContent = formatMoney(targetValue);
    }
  }

  update();
}

function formatMoney(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
